
//
// Options Button

optionsButton = {};

optionsButton.create = function() {
	var button = new PIXI.Container();

	InputHelpers.addGenerics(button);
	InputHelpers.addAutoplayFlag(button);
	InputHelpers.addCanSpinFlag(button);
    InputHelpers.addInfoPlatformEnabledFlag(button);
	InputHelpers.addRecoveryFlag(button);

	button.canEnable = function() {
		return (
			!this._flags.inRecovery &&
			this._flags.infoPlatformEnabled &&
			this._flags.canSpin &&
			!this._flags.autoplayStarted &&
			!this._flags.modal.active);
	};
	
	button.canShow = function() {
		return this._flags.infoPlatformVisible;
	};

	button.onPressedCallback = function() {
		helpPageManager.showPopup();
		if (button.soundName !== "") button.playSound();
	};

	return button;
};

optionsButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
optionsButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("optionsButton", optionsButton.create, optionsButton.initialise, optionsButton.getFilesRequired);